import OrganizationCard from "./OrganizationCard";
import clapProductions from "../images/clap-productions-cagnotte.jpg";
import cocoBeachHamjago from "../images/coco-beach.jpg";

function DonationCalls() {
  const organizations = [
    // {
    //   name: "Sauver la crèche Zaza M'zoury",
    //   objective:
    //     "Suite au passage du cyclone Chido à Mayotte le 14 décembre 2024, la crèche Zaza M'zoury de Tsingoni a subi d'importants dégâts. Nous sollicitons votre aide pour restaurer ce lieu essentiel à l'accueil et au développement des jeunes enfants.",
    //   verificationDate: "08/01/2025",
    //   source: "https://www.facebook.com/share/1ExbQt9NUC/?mibextid=wwXIfr",
    //   link: "https://www.leetchi.com/fr/c/sauver-la-creche-zaza-mzoury-1001600?utm_source=copylink&utm_medium=social_sharing",
    // },
    {
      name: "Sauvons les enfants de Tsararano, asso Wema Watrou",
      objective:
        "Avec le soutien de l’association historique Wema Watrou, nous apportons bons alimentaires, aquatabs pour potabiliser l’eau des rivières boueuses, visites de personnel médical, installations de groupes électrogènes. 1000 familles, 5300 habitants dans l'urgence à Tsararano, un peu loin des circuits aidés.",
      verificationDate: "15/01/2025",
      source: "https://www.facebook.com/claude.jaquier.7?locale=fr_FR",
      link: "https://www.leetchi.com/fr/c/sauvons-les-enfants-de-tsararano-a-mayotte-3432853?utm_source=copylink&utm_medium=social_sharing&fbclid=IwY2xjawH2UbZleHRuA2FlbQIxMQABHT6arTNHIt52amRFvY0IYNljt__HJcBE7caM9zQTz1mwek2usGoXiNqBqw_aem_-GcURlp4yyRUi537CJC-8w",
    },
    {
      name: "Sauver la crèche Zaza M'zoury",
      objective:
        "Suite au passage du cyclone Chido à Mayotte le 14 décembre 2024, la crèche Zaza M'zoury de Tsingoni a subi d'importants dégâts. Nous sollicitons votre aide pour restaurer ce lieu essentiel à l'accueil et au développement des jeunes enfants.",
      verificationDate: "15/01/2025",
      source: "https://www.facebook.com/share/1ExbQt9NUC/?mibextid=wwXIfr",
      link: "https://www.leetchi.com/fr/c/sauver-la-creche-zaza-mzoury-suite-au-cyclone-chido-1673603?utm_source=native&utm_medium=social_sharing",
    },
    {
      name: "Reconstruction de la grande mosquée de Vendredi à Pamandzi",
      objective:
        "La mosquée de Pamandzi (Mayotte), gravement endommagée par le cyclone Chido, nécessite une mobilisation collective pour sa reconstruction. Un appel aux dons est lancé pour permettre à la communauté de retrouver rapidement son lieu de culte et de rassemblement.",
      verificationDate: "10/01/2025",
      link: "https://www.leetchi.com/fr/c/reconstruction-de-la-grande-mosquee-de-vendredi-2565079?utm_source=copylink&utm_medium=social_sharing",
    },
    {
      name: "Association Saveurs et Senteurs de Mayotte Vanille Chido Mayotte",
      objective:
        "L'objectif est double : créer un fonds de secours pour aider les producteurs à restaurer leurs plantations endommagées et compenser leurs pertes de revenus, selon les fonds collectés.",
      verificationDate: "08/01/2025",
      source: "https://www.facebook.com/share/p/15UmpFaKJV/?mibextid=wwXIfr",
      link: "https://association-saveurs-et-senteurs-de-mayotte.s2.yapla.com/fr/campaign-10016/detail/vanille-chido-mayotte-cuisinez-solidaire/10016",
    },
    {
      name: "Chido - distribution premier soins",
      objective:
        "Suite à la catastrophe cyclonique qu'a connu mayotte. L'association Uwezo s'investi sur la distribution au sein des villages de Tsoundzou.",
      verificationDate: "05/01/2025",
      source: "https://www.helloasso.com/associations/uwezo",
      link: "https://www.helloasso.com/associations/uwezo/collectes/chido-distribution-premier-soins",
    },
    {
      name: "SOS CYCLONE CHIDO MAYOTTE",
      objective:
        "Des entrepreneurs et professeurs se mobilisent pour aider les victimes du cyclone Chido à Mayotte, particulièrement dans la zone de Mamoudzou, avec des distributions de produits essentiels aux habitants sinistrés.",
      verificationDate: "05/01/2025",
      source:
        "https://www.instagram.com/p/DD-KLnVo5bz/?igsh=MXdpZG5hMWZoNHBobw==",
      link: "https://www.onparticipe.fr/c/kHBswerh",
    },
    {
      name: "Association Nayma",
      objective:
        "L'association mène des actions d'urgence (eau potable, soins médicaux, soutien psychologique) et la cagnotte vise à soutenir ces opérations ainsi que les salariés précaires de Nayma qui assurent une présence terrain continue.",
      verificationDate: "30/12/2024",
      source: "https://www.facebook.com/AssociationNAYMA",
      link: "https://www.leetchi.com/fr/c/cyclonechidomayotte-association-nayma-8942916?utm_source=copylink&utm_medium=social_sharing",
    },
    {
      name: "Distribution Mrowahandra",
      objective:
        "Cagnotte solidaire afin de pouvoir faire les courses et distribuer des produits de premières nécessité dans le quartier de Mrowahandra. Les secours et les aides peinent à arriver dans certaines zones de l'île !",
      verificationDate: "30/12/2024",
      source:
        "https://www.instagram.com/reel/DD_teMLoR7y/?igsh=MW9zNzQ1bzF3aTUzYw==",
      link: "https://www.papayoux-solidarite.com/fr/collecte/cagnotte-distribution-mrowahandra",
    },
    {
      name: "Solidarité humaine et citoyenne pour Mayotte",
      objective:
        "Cette cagnotte a pour objectif de couvrir les frais d'envoi de colis humanitaires à destination de Mayotte depuis La Réunion.",
      verificationDate: "30/12/2024",
      source:
        "https://www.facebook.com/share/p/8BCweCvxM6FfE1HQ/?mibextid=wwXIfr",
      link: "https://www.leetchi.com/fr/c/solidarite-humaine-et-citoyenne-pour-mayotte-9266050",
    },
    {
      name: "Solidarité Mayotte (Cloturée)",
      objective:
        "L’objectif est de collecter de l’argent pour faire des courses, puis de les distribuer à Labattoir, sur Petite Terre.",
      verificationDate: "27/12/2024",
      source:
        "https://www.facebook.com/share/p/fGq3To4x5vCuW49j/?mibextid=wwXIfr",
      link: "https://www.leetchi.com/fr/c/solidarite-mayotte-1130768?utm_source=copylink&utm_medium=social_sharing",
    },
    {
      name: "Reconstruction de serres agricoles",
      objective:
        "Reconstruction de serres agricoles suite au passage du cyclone Chido à Mayotte",
      verificationDate: "27/12/2024",
      source:
        "https://www.facebook.com/share/jHTZRVBngJ6y5Vxa/?mibextid=wwXIfr",
      link: "https://www.leetchi.com/fr/c/reconstruction-de-serres-agricoles-suite-au-passage-du-cyclone-chido-a-mayotte-4667870?utm_source=copylink&utm_medium=social_sharing",
    },
    {
      name: "Pour les oubliés de Mayotte (Cloturée)",
      objective:
        "Avec votre aide, nous pourrons leur offrir de la nourriture, de l’eau potable, des produits de première nécessité, des vêtements et des fournitures scolaires.",
      verificationDate: "24/12/2024",
      source: "https://www.instagram.com/stories/highlights/18483235234057972/",
      link: "https://www.leetchi.com/fr/c/pour-les-oublies-de-mayotte-1005600?utm_source=native&utm_medium=social_sharing",
    },
    {
      name: "Après le cyclone Chido à Mayotte, je soutiens Pamandzi",
      objective:
        "Cette cagnotte est une lueur d'espoir dans l'obscurité, permettant de répondre aux besoins immédiats sur le terrain, en attendant l'arrivée des conteneurs.",
      verificationDate: "24/12/2024",
      link: "https://www.leetchi.com/fr/c/apres-le-cyclone-chido-a-mayotte-je-soutiens-pamandzi-9908527",
    },
    {
      name: "Charline pour achat matériel médical",
      objective:
        "Les secours étant pour le moment insuffisants pour gérer la situation, cette cagnotte a été créée pour réunir des fonds et acheter du matériel médical (pansement, compresse, antiseptique, etc) et fournir les soignants bénévoles présents déjà sur place et apporter une première aide médicale.",
      verificationDate: "24/12/2024",
      source:
        "https://www.instagram.com/reel/DD7bt_NoqA1/?igsh=MTBveXJ5anlxaHRsdg==",
      link: "https://www.leetchi.com/fr/c/solidarite-mayotte-achat-materiel-medical-1356781?utm_source=native&utm_medium=social_sharing",
    },
    // {
    //   name: "Naftal Dylan Petite-Terre",
    //   objective:
    //     "Chaque contribution, petite ou grande, permettra de fournir des abris temporaires, de l’eau potable, des vêtements, et de reconstruire ce qui a été perdu. Aidez-nous à redonner espoir à ceux qui ont tout perdu. Ensemble, nous pouvons faire une différence.",
    //   verificationDate: "24/12/2024",
    //   source:
    //     "https://www.instagram.com/reel/DD8lWM0CGa_/?igsh=bmVrcnFpa3cwY2V6",
    //   link: "https://www.leetchi.com/fr/c/cyclone-chido-mayotte-6591285?utm_source=native&utm_medium=social_sharing",
    // },
    {
      name: "Maor'aide",
      objective: "Distribution alimentaire de repas.",
      verificationDate: "24/12/2024",
      source:
        "https://www.facebook.com/share/p/v7kweBmvYhiSysAk/?mibextid=wwXIfr",
      link: "https://www.helloasso.com/associations/maor-aide",
    },
    {
      name: "Cagnotte Petite-Terre",
      objective:
        "Nous avons créé cette cagnotte pour aider directement les Mahorais de Petite-Terre de subvenir à leurs besoins. Chaque don permettra de fournir des kits d’urgence (nourriture, eau, vêtements, médicaments) aux familles en difficulté.",
      verificationDate: "24/12/2024",
      link: "https://www.leetchi.com/fr/c/petite-terre-a-besoin-de-vous-2059440?utm_source=native&utm_medium=social_sharing",
    },
    {
      name: "Mayotte a faim (Cloturée)",
      objective:
        "Distribution de colis alimentaires dans les villages les plus reculés de Mayotte.",
      verificationDate: "22/12/2024",
      link: "https://www.cotizup.com/mayotte-a-faim-parnous-pournou",
    },
    {
      name: "Coco Beach Hamjago (Cloturée)",
      objective: "Aidez-nous les à continuer l'entraide !",
      verificationDate: "22/12/2024",
      imageUrl: cocoBeachHamjago,
      link: "https://www.leetchi.com/fr/c/soutien-au-coco-beach-hamjago-a-mayotte-aidez-nous-a-continuer-lentraide-1825731?utm_source=copylink&utm_medium=social_sharing",
    },
    {
      name: "CLAP PRODUCTIONS",
      objective:
        "Aidons les épiceries solidaires de Mayotte pour soutenir les hommes et les femmes de l’île !",
      verificationDate: "19/12/2024",
      imageUrl: clapProductions,
      link: "https://tribee.fr/participations/7KT22Z141A9RJTZS64JVD2GQ8B",
    },
    {
      name: "Dorian Fantas (Cloturée)",
      objective:
        "Pour aider les voisins de Dorian qui n'ont reçu aucune aide pour l'instant.",
      verificationDate: "22/12/2024",
      link: "https://lydia-app.com/pots?id=82064-voisins-mayotte",
    },
  ];

  return (
    <div className="donations-grid">
      {organizations.map((org, index) => (
        <OrganizationCard
          key={index}
          organization={org.name}
          objective={org.objective}
          verificationDate={org.verificationDate}
          imageUrl={org.imageUrl}
          source={org.source}
          link={org.link}
        />
      ))}
    </div>
  );
}

export default DonationCalls;
